import { Routes } from "@angular/router";
import { AuthGuard } from "./core/guards/auth.guard";
import { mainLayoutResolver } from "./layouts/main/main-layout.resolver";

export const appRoutes: Routes = [
  {
    path: "",
    canActivate: [AuthGuard],
    resolve: {
      session: mainLayoutResolver,
    },
    loadComponent: () => import("./layouts/main/main.component"),
    loadChildren: () => import("./layouts/main/main.layout.routes"),
  },
  {
    path: "auth",
    loadComponent: () => import("./layouts/auth/auth.component"),
    loadChildren: () => import("./modules/authentication/authentication.routes"),
  },
  {
    path: "privacy-policy",
    loadComponent: () =>
      import("./modules/privacy-policy/pages/privacy-policy/privacy-policy.component"),
  },
  {
    path: "privacy-policy-ar",
    loadComponent: () =>
      import("./modules/privacy-policy/pages/privacy-policy-ar/privacy-policy-ar.component"),
  },
  {
    path: "external-people-mate",
    loadComponent: () => import("./layouts/external-people-mate/external-people-mate.component"),
    loadChildren: () => import("./layouts/external-people-mate/external-people-mate.routes"),
  },
  {
    path: "setup-stepper",
    loadComponent: () =>
      import("../app/modules/company-setup/pages/setup-stepper/setup-stepper.component"),
  },
  {
    path: "**",
    loadComponent: () =>
      import("./pages/not-found/not-found.component").then(page => page.NotFoundComponent),
  },
];
